import React from "react";
import { useNavigate } from 'react-router-dom';
import Popup from "../../../components/Popups/Popup";
import CreateItemView from '../../Items/Components/CreateItem';
import DataService from "../../../services/data.service";
import ItemRevisionModel from '../../../models/ItemRevisionModel';

interface PopupProps {
    projectId?: number
    projectTypeId?: number
    show: boolean
    onHide: () => void
}

const CreateItemPopup: React.FC<PopupProps> = ({ show, onHide, projectId, projectTypeId }) => {
    const navigate = useNavigate();

    function onItemCreated(itemId: number) {
        DataService
            .get<ItemRevisionModel[]>('api/v1/ItemRevisions/ByItem/' + itemId)
            .then(response => { navigate('/plm/items/itemrevision/' + response[0].id); })
    }

    let title = 'Create new item'
    if (projectId)
        title += ' for project ' + projectId

    return (
        <Popup show={show} onHide={onHide} size={'xl'} title={title} >
            <Popup.Body>
                <CreateItemView projectId={projectId} projectTypeId={projectTypeId} onItemCreated={onItemCreated} />
            </Popup.Body>
        </Popup>
    );
}
export default CreateItemPopup;